import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/dashboard/banners',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/dashboard/banners/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\BannerController::store
* @see app/Http/Controllers/BannerController.php:60
* @route '/dashboard/banners'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/dashboard/banners',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BannerController::store
* @see app/Http/Controllers/BannerController.php:60
* @route '/dashboard/banners'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BannerController::store
* @see app/Http/Controllers/BannerController.php:60
* @route '/dashboard/banners'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BannerController::store
* @see app/Http/Controllers/BannerController.php:60
* @route '/dashboard/banners'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BannerController::store
* @see app/Http/Controllers/BannerController.php:60
* @route '/dashboard/banners'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/{banner}/statistics'
*/
export const statistics = (args: { banner: string | number } | [banner: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: statistics.url(args, options),
    method: 'get',
})

statistics.definition = {
    methods: ["get","head"],
    url: '/dashboard/banners/{banner}/statistics',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/{banner}/statistics'
*/
statistics.url = (args: { banner: string | number } | [banner: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { banner: args }
    }

    if (Array.isArray(args)) {
        args = {
            banner: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        banner: args.banner,
    }

    return statistics.definition.url
            .replace('{banner}', parsedArgs.banner.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/{banner}/statistics'
*/
statistics.get = (args: { banner: string | number } | [banner: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: statistics.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/{banner}/statistics'
*/
statistics.head = (args: { banner: string | number } | [banner: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: statistics.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/{banner}/statistics'
*/
const statisticsForm = (args: { banner: string | number } | [banner: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: statistics.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/{banner}/statistics'
*/
statisticsForm.get = (args: { banner: string | number } | [banner: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: statistics.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/{banner}/statistics'
*/
statisticsForm.head = (args: { banner: string | number } | [banner: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: statistics.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

statistics.form = statisticsForm

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/{banner}/edit'
*/
export const edit = (args: { banner: string | number } | [banner: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/dashboard/banners/{banner}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/{banner}/edit'
*/
edit.url = (args: { banner: string | number } | [banner: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { banner: args }
    }

    if (Array.isArray(args)) {
        args = {
            banner: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        banner: args.banner,
    }

    return edit.definition.url
            .replace('{banner}', parsedArgs.banner.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/{banner}/edit'
*/
edit.get = (args: { banner: string | number } | [banner: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/{banner}/edit'
*/
edit.head = (args: { banner: string | number } | [banner: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/{banner}/edit'
*/
const editForm = (args: { banner: string | number } | [banner: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/{banner}/edit'
*/
editForm.get = (args: { banner: string | number } | [banner: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/banners/{banner}/edit'
*/
editForm.head = (args: { banner: string | number } | [banner: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\BannerController::update
* @see app/Http/Controllers/BannerController.php:101
* @route '/dashboard/banners/{banner}'
*/
export const update = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/dashboard/banners/{banner}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\BannerController::update
* @see app/Http/Controllers/BannerController.php:101
* @route '/dashboard/banners/{banner}'
*/
update.url = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { banner: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { banner: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            banner: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        banner: typeof args.banner === 'object'
        ? args.banner.id
        : args.banner,
    }

    return update.definition.url
            .replace('{banner}', parsedArgs.banner.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\BannerController::update
* @see app/Http/Controllers/BannerController.php:101
* @route '/dashboard/banners/{banner}'
*/
update.put = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\BannerController::update
* @see app/Http/Controllers/BannerController.php:101
* @route '/dashboard/banners/{banner}'
*/
const updateForm = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BannerController::update
* @see app/Http/Controllers/BannerController.php:101
* @route '/dashboard/banners/{banner}'
*/
updateForm.put = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\BannerController::destroy
* @see app/Http/Controllers/BannerController.php:117
* @route '/dashboard/banners/{banner}'
*/
export const destroy = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/dashboard/banners/{banner}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\BannerController::destroy
* @see app/Http/Controllers/BannerController.php:117
* @route '/dashboard/banners/{banner}'
*/
destroy.url = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { banner: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { banner: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            banner: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        banner: typeof args.banner === 'object'
        ? args.banner.id
        : args.banner,
    }

    return destroy.definition.url
            .replace('{banner}', parsedArgs.banner.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\BannerController::destroy
* @see app/Http/Controllers/BannerController.php:117
* @route '/dashboard/banners/{banner}'
*/
destroy.delete = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\BannerController::destroy
* @see app/Http/Controllers/BannerController.php:117
* @route '/dashboard/banners/{banner}'
*/
const destroyForm = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BannerController::destroy
* @see app/Http/Controllers/BannerController.php:117
* @route '/dashboard/banners/{banner}'
*/
destroyForm.delete = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\BannerController::uploadMedia
* @see app/Http/Controllers/BannerController.php:129
* @route '/dashboard/banners/{banner}/media'
*/
export const uploadMedia = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: uploadMedia.url(args, options),
    method: 'post',
})

uploadMedia.definition = {
    methods: ["post"],
    url: '/dashboard/banners/{banner}/media',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BannerController::uploadMedia
* @see app/Http/Controllers/BannerController.php:129
* @route '/dashboard/banners/{banner}/media'
*/
uploadMedia.url = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { banner: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { banner: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            banner: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        banner: typeof args.banner === 'object'
        ? args.banner.id
        : args.banner,
    }

    return uploadMedia.definition.url
            .replace('{banner}', parsedArgs.banner.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\BannerController::uploadMedia
* @see app/Http/Controllers/BannerController.php:129
* @route '/dashboard/banners/{banner}/media'
*/
uploadMedia.post = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: uploadMedia.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BannerController::uploadMedia
* @see app/Http/Controllers/BannerController.php:129
* @route '/dashboard/banners/{banner}/media'
*/
const uploadMediaForm = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: uploadMedia.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BannerController::uploadMedia
* @see app/Http/Controllers/BannerController.php:129
* @route '/dashboard/banners/{banner}/media'
*/
uploadMediaForm.post = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: uploadMedia.url(args, options),
    method: 'post',
})

uploadMedia.form = uploadMediaForm

/**
* @see \App\Http\Controllers\BannerController::deleteMedia
* @see app/Http/Controllers/BannerController.php:179
* @route '/dashboard/banners/{banner}/media/{media}'
*/
export const deleteMedia = (args: { banner: string | number | { id: string | number }, media: string | number } | [banner: string | number | { id: string | number }, media: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMedia.url(args, options),
    method: 'delete',
})

deleteMedia.definition = {
    methods: ["delete"],
    url: '/dashboard/banners/{banner}/media/{media}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\BannerController::deleteMedia
* @see app/Http/Controllers/BannerController.php:179
* @route '/dashboard/banners/{banner}/media/{media}'
*/
deleteMedia.url = (args: { banner: string | number | { id: string | number }, media: string | number } | [banner: string | number | { id: string | number }, media: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            banner: args[0],
            media: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        banner: typeof args.banner === 'object'
        ? args.banner.id
        : args.banner,
        media: args.media,
    }

    return deleteMedia.definition.url
            .replace('{banner}', parsedArgs.banner.toString())
            .replace('{media}', parsedArgs.media.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\BannerController::deleteMedia
* @see app/Http/Controllers/BannerController.php:179
* @route '/dashboard/banners/{banner}/media/{media}'
*/
deleteMedia.delete = (args: { banner: string | number | { id: string | number }, media: string | number } | [banner: string | number | { id: string | number }, media: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMedia.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\BannerController::deleteMedia
* @see app/Http/Controllers/BannerController.php:179
* @route '/dashboard/banners/{banner}/media/{media}'
*/
const deleteMediaForm = (args: { banner: string | number | { id: string | number }, media: string | number } | [banner: string | number | { id: string | number }, media: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteMedia.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BannerController::deleteMedia
* @see app/Http/Controllers/BannerController.php:179
* @route '/dashboard/banners/{banner}/media/{media}'
*/
deleteMediaForm.delete = (args: { banner: string | number | { id: string | number }, media: string | number } | [banner: string | number | { id: string | number }, media: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteMedia.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

deleteMedia.form = deleteMediaForm

const banners = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    statistics: Object.assign(statistics, statistics),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    uploadMedia: Object.assign(uploadMedia, uploadMedia),
    deleteMedia: Object.assign(deleteMedia, deleteMedia),
}

export default banners